<app-loading-spinner *ngIf="isLoading" />


<div *ngIf="!isLoading" class="block min-w-0" style="container: centre-target / inline-size;">
    <div class="[@container_centre-target_(max-width:64rem)]:flex-wrap [@container_centre-target_(max-width:64rem)]:gap-4 flex flex-row justify-between items-center">
        <p class="[@container_centre-target_(max-width:64rem)]:ml-0 [@container_centre-target_(max-width:64rem)]:text-left [@container_centre-target_(max-width:64rem)]:[overflow-wrap:anywhere] text-[16px] font-bold ml-8 text-right dark:text-white text-[#030308]">{{centerDetails.regCode}}
            {{centerDetails.centerName}}</p>
        <div class="[@container_centre-target_(max-width:64rem)]:flex-wrap [@container_centre-target_(max-width:64rem)]:gap-4 [@container_centre-target_(max-width:64rem)]:[&>i]:ml-0 [@container_centre-target_(max-width:30rem)]:w-full flex flex-row items-center gap-5 ">
            <i class="fa-solid fa-list text-lg text-[#4A4A4A] dark:text-white ml-5"></i>

            <p class="font-[400] text-[#4A4A4A] dark:text-white text-sm">Collection Date:</p>

            <div class="w-28">
                <app-custom-datepicker [showClearButton]="false" [selectedDate]="selectDatePickerDate"
                    (dateChange)="onDateChange($event)"></app-custom-datepicker>
            </div>

            <div class="[@container_centre-target_(max-width:64rem)]:mr-0 [@container_centre-target_(max-width:64rem)]:max-w-full [@container_centre-target_(max-width:64rem)]:[&_input]:min-w-0 [@container_centre-target_(max-width:64rem)]:[&_button]:shrink-0 [@container_centre-target_(max-width:30rem)]:w-full flex items-center rounded-full mr-16 ml-0 px-4 py-2 w-80 bg-[#F1F1F1] dark:bg-[#292929]">
                <input type="text" placeholder="Search by Crop / Variety Name" [(ngModel)]="searchText"
                    (keyup.enter)="onSearch()" (keyup.esc)="offSearch()"
                    (ngModelChange)="searchText = $event.trimStart()"
                    class="bg-transparent outline-none w-full text-textLight dark:text-textDark" />
                <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                    (click)="onSearch()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                    </svg>
                </button>
                <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                    (click)="offSearch()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

        </div>
    </div>

    <div *ngIf="hasData" class="[@container_centre-target_(max-width:64rem)]:px-0 [@container_centre-target_(max-width:64rem)]:[&>.mr-5]:mr-0 w-full pl-8 pr-10 bg-tileLight dark:bg-[#363636] ">
        <div
            class="flex items-center gap-2 mt-8 mr-5 px-4 py-3 rounded-lg bg-[#EDF5FC] text-sm font-[400] text-[#000000] dark:text-gray-800">
            <i class="fa-solid fa-circle-info text-[#415CFF]"></i>
            <p>Collections for deliveries scheduled on {{ scheduledDeliveryDate }} must be completed on {{
                mustCompleteDate }}. These collections will appear in the system on {{ systemAppearDate }} at 7:00 PM.
            </p>
        </div>

        <div class="overflow-x-auto mt-8 mr-5 border-gray-100 border-[2px] rounded-lg">
            <table class="w-full divide-y-2 overflow-hidden">
                <thead class=" dark:bg-[#292929] text-base text-[#000000] dark:text-gray-300">
                    <tr>
                        <th class="whitespace-nowrap px-6 py-3 text-center font-medium">ITEM ({{countCrops < 10 ? '0' +
                                countCrops : countCrops}})</th>
                        <th class="px-6 py-3 text-left text-base text-[#000000] dark:text-gray-300 font-medium">Crop
                        </th>
                        <th class="px-6 py-3 text-left text-base text-[#000000] dark:text-gray-300 font-medium">Variety
                        </th>
                        <th class="px-6 py-3 text-left text-base text-[#000000] dark:text-gray-300 font-medium">Grade A
                        </th>
                        <th class="px-6 py-3 text-left text-base text-[#000000] dark:text-gray-300 font-medium">Grade B
                        </th>
                        <th class="px-6 py-3 text-left text-base text-[#000000] dark:text-gray-300 font-medium">Grade C
                        </th>
                    </tr>
                </thead>
                <tbody class="bg-white dark:bg-[#292929]">
                    <ng-container *ngFor="let item of assignCropsArr; let i = index">
                        <tr class="whitespace-nowrap align-top">
                            <td
                                class="whitespace-nowrap px-6 py-3 text-center text-base text-[#000000] dark:text-gray-300 align-top">
                                {{ (i + 1) < 10 ? '0' + (i + 1) : (i + 1) }} </td>
                            <td class="px-6 py-3 text-base text-[#000000] dark:text-gray-300 align-top">
                                {{item.cropNameEnglish}}</td>
                            <td class="px-6 py-3 text-base text-[#000000] dark:text-gray-300 align-top">
                                {{item.varietyNameEnglish}}</td>

                            <!-- Grade A Column -->
                            <td class="px-6 py-3 text-base text-[#000000] dark:text-gray-300 align-top"
                                [class.grade-editing-cell]="item.editingA">
                                <input type="number" [(ngModel)]="item.targetA" step="any" name="targetA" min="0"
                                    (change)="checkNegativeValue(item, 'A')"
                                    (blur)="resetEmptyTargets(item)"
                                    (input)="restrictDecimal($event, item, 'A')"
                                    class="dark:bg-[#363636] border-[2px] border-dotted rounded-lg w-28 px-2 py-1 mr-4 focus:outline-none"
                                    [ngClass]="isGradeInvalid(item, 'A') ? 'border-[#FF0000]' : 'border-[#415CFF]'"
                                    [disabled]="!item.isNew && !item.editingA" />
                                <button *ngIf="!item.isNew && !item.editingA && isDateValid"
                                    [disabled]="isAnyGradeEditing"
                                    (click)="(item.editingA = true) && pressEditIcon(item,'A')">
                                    <i class="fa-solid fa-pen-to-square text-xl"
                                        [ngClass]="isAnyGradeEditing ? 'text-gray-400 cursor-not-allowed' : 'text-[#415CFF]'"></i>
                                </button>
                                <button *ngIf="!item.isNew && item.editingA && isDateValid"
                                    class="px-3 py-2 text-white rounded-lg"
                                    [ngClass]="isSaveDisabled(item, 'A') ? 'bg-[#6B7D8C]' : 'bg-[#415CFF]'"
                                    [disabled]="isSaveDisabled(item, 'A')"
                                    (click)="saveGrade('A', item, item.targetA, item.idA)">
                                    Save
                                </button>
                                <div *ngIf="(item.isNew || item.editingA || item.editingB || item.editingC) && isQtyExceeded(item)"
                                    class="flex items-center gap-1 mt-1 w-28 whitespace-nowrap text-xs text-red-600 dark:text-red-400">
                                    <i class="fa-solid fa-triangle-exclamation text-[#FF0000]"></i>
                                    <span class="text-[#FF0000] font-[400] ">Only {{ item.remaining }} {{
                                        item.unitType.toLowerCase() }} remains to assign; you cannot assign more.</span>
                                </div>
                            </td>

                            <!-- Grade B Column -->
                            <td class="px-6 py-3 text-base text-[#000000] dark:text-gray-300 align-top"
                                [class.grade-editing-cell]="item.editingB">
                                <input type="number" [(ngModel)]="item.targetB" step="any" name="targetB" min="0"
                                    (change)="checkNegativeValue(item, 'B')"
                                    (blur)="resetEmptyTargets(item)"
                                    (input)="restrictDecimal($event, item, 'B')"
                                    class="dark:bg-[#363636] border-[2px] border-dotted rounded-lg w-28 px-2 py-1 mr-4 focus:outline-none"
                                    [ngClass]="isGradeInvalid(item, 'B') ? 'border-[#FF0000]' : 'border-[#415CFF]'"
                                    [disabled]="!item.isNew && !item.editingB" />
                                <button *ngIf="!item.isNew && !item.editingB && isDateValid"
                                    [disabled]="isAnyGradeEditing"
                                    (click)="(item.editingB = true) && pressEditIcon(item,'B')">
                                    <i class="fa-solid fa-pen-to-square text-xl"
                                        [ngClass]="isAnyGradeEditing ? 'text-gray-400 cursor-not-allowed' : 'text-[#415CFF]'"></i>
                                </button>
                                <button *ngIf="!item.isNew && item.editingB && isDateValid"
                                    class="px-3 py-2 text-white rounded-lg"
                                    [ngClass]="isSaveDisabled(item, 'B') ? 'bg-[#6B7D8C]' : 'bg-[#415CFF]'"
                                    [disabled]="isSaveDisabled(item, 'B')"
                                    (click)="saveGrade('B', item, item.targetB, item.idB)">
                                    Save
                                </button>
                            </td>

                            <!-- Grade C Column -->
                            <td class="px-6 py-3 text-base text-[#000000] dark:text-gray-300 align-top"
                                [class.grade-editing-cell]="item.editingC">
                                <input type="number" [(ngModel)]="item.targetC" step="any" name="targetC" min="0"
                                    (change)="checkNegativeValue(item, 'C')"
                                    (blur)="resetEmptyTargets(item)"
                                    (input)="restrictDecimal($event, item, 'C')"
                                    class="dark:bg-[#363636] border-[2px] border-dotted rounded-lg w-28 px-2 py-1 mr-4 focus:outline-none"
                                    [ngClass]="isGradeInvalid(item, 'C') ? 'border-[#FF0000]' : 'border-[#415CFF]'"
                                    [disabled]="!item.isNew && !item.editingC" />
                                <button *ngIf="!item.isNew && !item.editingC && isDateValid"
                                    [disabled]="isAnyGradeEditing"
                                    (click)="(item.editingC = true) && pressEditIcon(item,'C')">
                                    <i class="fa-solid fa-pen-to-square text-xl"
                                        [ngClass]="isAnyGradeEditing ? 'text-gray-400 cursor-not-allowed' : 'text-[#415CFF]'"></i>
                                </button>
                                <button *ngIf="!item.isNew && item.editingC && isDateValid"
                                    class="px-3 py-2 text-white rounded-lg"
                                    [ngClass]="isSaveDisabled(item, 'C') ? 'bg-[#6B7D8C]' : 'bg-[#415CFF]'"
                                    [disabled]="isSaveDisabled(item, 'C')"
                                    (click)="saveGrade('C', item, item.targetC, item.idC)">
                                    Save
                                </button>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>

        <div *ngIf="hasNewItems && isDateValid" class="flex flex-row flex-wrap justify-center items-center my-7 gap-8">
            <button class="w-32 bg-[#FFFFFF] text-[#6B7D8C] border-[1px] border-[#95A1AC]  rounded-lg px-7 py-2"
                (click)="onCancel()">
                Cancel
            </button>
            <button class="w-32 rounded-lg px-7 py-2 "
                [ngClass]="isFormValid ? 'bg-[hsl(231,100%,63%)] text-[#FFFFFF] shadow-md' : 'bg-[#95A1AC] text-[#6B7D8C]'"
                [disabled]="!isFormValid" (click)="onSubmit()">
                Save
            </button>
        </div>

    </div>

    <div *ngIf="!hasData"
        class="flex flex-col items-center w-full h-screen px-10 py-7 bg-tileLight dark:bg-[#363636] rounded-lg dark:text-black">
        <p class="text-[#494949] my-6 dark:text-[#FFFFFF]">--No Data Available--</p>
        <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20 dark:text-black" />
    </div>

    <div *ngIf="showConfirmModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 overflow-y-auto">
        <div
            class="bg-white dark:bg-[#363636] rounded-2xl shadow-xl w-[520px] max-w-full max-h-full overflow-y-auto px-4 sm:px-10 py-10 flex flex-col items-center text-center">
            <h2 class="text-xl text-[#000000] font-[600] dark:text-white">Finish up!</h2>
            <p class="text-sm text-[##534E4E] font-[300] dark:text-gray-300 mt-3 leading-relaxed">
                Marking as completed in {{ confirmDurationSeconds }} seconds.<br />
                Tap 'Go Back' to edit.
            </p>

            <div class="relative w-40 h-40 my-8">
                <svg class="w-full h-full -rotate-90" viewBox="0 0 120 120">
                    <circle cx="60" cy="60" r="54" fill="none" stroke="#E5E7EB" stroke-width="4" />
                    <circle cx="60" cy="60" r="54" fill="none" stroke="hsl(231,100%,63%)" stroke-width="4"
                        stroke-linecap="round" [attr.stroke-dasharray]="confirmCircumference"
                        [attr.stroke-dashoffset]="confirmDashOffset" style="transition: stroke-dashoffset 1s linear;" />
                </svg>
                <div
                    class="absolute inset-0 flex items-center justify-center text-2xl font-semibold text-[#000000E0] font-300 dark:text-white">
                    {{ confirmFormattedTime }}
                </div>
            </div>

            <div class="flex flex-col sm:flex-row gap-4 w-full">
                <button type="button"
                    class="flex-1 rounded-xl px-6 py-3 bg-[#F6F7F9] border-2 border-[#95A1AC] font-[600] text-[#6B7D8C] dark:text-white dark:border-gray-500"
                    (click)="onCancelConfirm()">
                    Back to Edit
                </button>
                <button type="button"
                    class="flex-1  border-2 border-[#415CFF] rounded-xl px-6 py-3 font-[600] bg-[#415CFF] text-[#FFFFFF] shadow-lg"
                    (click)="onConfirmSave()">
                    Confirm & Save
                </button>
            </div>
        </div>
    </div>
</div>
